module.exports = __webpack_public_path__ + "img/edit-profile-button.4a85b951.png";